import React from 'react';
import { Typography } from '@mui/material';
import { colors } from '../../../theme';

interface SectionHeaderProps {
  children: React.ReactNode;
  color?: 'deepNavy' | 'pureWhite';
  marginBottom?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  children,
  color = 'deepNavy',
  marginBottom = '48px',
}) => {

  return (
    <Typography
      variant="h2"
      sx={{
        fontSize: { xs: '1.75rem', md: '2.5rem' },
        fontWeight: 700,
        textAlign: 'center',
        marginBottom,
        color: colors[color],
      }}
    >
      {children}
    </Typography>
  );
};
